import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnChanges,
    ViewChild,
} from '@angular/core';
import { DrawPipeHelper } from 'app/shared/helpers/draw-pipe.helper';
import { INSTALLATION_TYPE } from 'app/shared/models/location-details';
import { hasFlexInstallationDrawingData } from '../flex-monitor-status.mapper';
import type { FlexInstallationDrawingData, FlexResource } from '../flex-monitor-status.models';

@Component({
    selector: 'app-flex-installation-drawing',
    templateUrl: './flex-installation-drawing.component.html',
    styleUrls: ['./flex-installation-drawing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlexInstallationDrawingComponent implements AfterViewInit, OnChanges {
    @ViewChild('pipeCanvas') private pipeCanvas: ElementRef<HTMLCanvasElement>;

    @Input() public resource: FlexResource<FlexInstallationDrawingData> = { state: 'idle', data: null };
    @Input() public installationType = '';
    @Input() public caption = '';
    @Input() public ariaLabel = '';
    @Input() public isDarkTheme = false;

    public hasDrawing = false;
    public hasRenderError = false;

    private viewInitialized = false;

    constructor(private drawPipeHelper: DrawPipeHelper, private cdr: ChangeDetectorRef) {}

    public ngAfterViewInit(): void {
        this.viewInitialized = true;
        this.renderDrawing();
    }

    public ngOnChanges(): void {
        this.renderDrawing();
    }

    public get isLoading(): boolean {
        return this.resource.state === 'idle' || this.resource.state === 'loading';
    }

    public get isPipeInstallation(): boolean {
        return this.installationType === INSTALLATION_TYPE.PIPE;
    }

    private renderDrawing(): void {
        if (!this.viewInitialized) return;

        const data = this.resource.data;
        if (!hasFlexInstallationDrawingData(data)) {
            this.clearDrawing();
            return;
        }

        try {
            this.drawPipeHelper.drawPipe(this.pipeCanvas, data.cosmos, data.units, this.isDarkTheme);
            this.hasDrawing = true;
            this.hasRenderError = false;
        } catch {
            this.clearDrawing(true);
        }
        this.cdr.markForCheck();
    }

    private clearDrawing(hasRenderError = false): void {
        const canvas = this.pipeCanvas.nativeElement;
        canvas.getContext('2d')?.clearRect(0, 0, canvas.width, canvas.height);
        this.hasDrawing = false;
        this.hasRenderError = hasRenderError;
        this.cdr.markForCheck();
    }
}
